import { EasypayImportFile, EasypayImportFileCouple } from './easypay-import-file.interface';
import { EasypayImportFileService } from './easypay-import-file.service';

import { ApiResource } from '@/core/models/ApiResource.interface';
import { Patch } from '@/core/models/patch.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import easypayEmployeeMapping, { EasypayEmployeeMappingState } from './easypay-employee-mappings/easypay-employee-mapping.store';

const service = new EasypayImportFileService();

export interface EasypayImportFileState {
   easypayImportFileCouplesOverview?: ApiResource<Array<EasypayImportFileCouple>>;

   easypayEmployeeMapping?: EasypayEmployeeMappingState;
}

const EasypayImportFileStore: Module<EasypayImportFileState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_EASYPAY_IMPORT_FILE_COUPLES_OVERVIEW(state: EasypayImportFileState, overview: ApiResource<Array<EasypayImportFileCouple>>) {
         return (state.easypayImportFileCouplesOverview = overview);
      },
      SET_EASYPAY_IMPORT_FILE_COUPLE(state: EasypayImportFileState, easypayImportFile: EasypayImportFile) {
         const index = (state.easypayImportFileCouplesOverview?.data || []).findIndex(
            (couple) => couple.contract_import_file.id === easypayImportFile.id || couple.employee_import_file.id === easypayImportFile.id,
         );

         if (index > -1) {
            const couple = state.easypayImportFileCouplesOverview!.data[index];

            return state.easypayImportFileCouplesOverview?.data?.splice(index, 1, {
               ...state.easypayImportFileCouplesOverview.data[index],
               contract_import_file:
                  couple.contract_import_file.id === easypayImportFile.id ? easypayImportFile : couple.contract_import_file,
               employee_import_file:
                  couple.employee_import_file.id === easypayImportFile.id ? easypayImportFile : couple.employee_import_file,
            });
         }
      },
   },
   actions: {
      async getEasypayImportFileUrls(context: any, ids: Array<number>) {
         return service.getEasypayImportFileUrls(ids);
      },
      async patchEasypayImportFile(context: any, payload: { importFileId: number; body: Array<Patch> }) {
         const response = await service.patchEasypayImportFile(payload.importFileId, payload.body);
         context.commit('SET_EASYPAY_IMPORT_FILE_COUPLE', response);
         return response;
      },
      async getEasypayImportFileCouples(context, query: LocationQuery) {
         const response = await service.getEasypayImportFileCouples(query);
         context.commit('SET_EASYPAY_IMPORT_FILE_COUPLES_OVERVIEW', response);
         return response;
      },
      async getEasypayImportErrorFileUrls(context: any, ids: Array<number>) {
         return service.getEasypayImportErrorFileUrls(ids);
      },
   },
   modules: {
      easypayEmployeeMapping,
   },
};

export default EasypayImportFileStore;
